export type LicenseDetailTab = "overview" | "seats" | "configuration" | "audit";

export function activationIDFromFocus(focus: string) {
  return focus.startsWith("activation:") ? focus.slice("activation:".length) : "";
}

export function productKeyIDFromFocus(focus: string) {
  const prefix = "product-key:";
  return focus.startsWith(prefix) ? focus.slice(prefix.length) : "";
}

export function licenseDetailTab(tab: string | null, focus: string): LicenseDetailTab {
  if (activationIDFromFocus(focus) || productKeyIDFromFocus(focus)) return "seats";
  if (tab === "product-keys" || tab === "devices" || tab === "seats") return "seats";
  if (tab === "audit") return "audit";
  if (tab === "configuration" || tab === "settings" || tab === "edit") return "configuration";
  return "overview";
}
